<template>
  <app-layout>
    <div
        class="bg-white lg:shadow-lg p-6 lg:py-12 lg:px-16 mx-auto lg:max-w-4xl lg:mt-20 flex flex-1 lg:flex-grow-0 flex-wrap justify-center">
      <h2 class="w-full capitalize text-center mb-8 text-dark-blue">{{ $trans('app.forgot-password') }}</h2>
      <jet-validation-errors class="w-full text-center mb-8"/>

      <div class="mb-4 text-sm text-gray-600">
        {{ $trans('app.forgot-password-explanation') }}
      </div>

      <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
        {{ status }}
      </div>

      <form @submit.prevent="submit" class="lg:w-1/2">
        <div>
          <jet-label for="email" value="Email"/>
          <jet-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus/>
        </div>

        <div class="flex items-center justify-end mt-4">
          <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
            {{ $trans('app.send-link') }}
          </jet-button>
        </div>
      </form>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetLabel from '@/Jetstream/Label'
import JetValidationErrors from '@/Jetstream/ValidationErrors'

export default {
  components: {
    AppLayout,
    JetAuthenticationCard,
    JetAuthenticationCardLogo,
    JetButton,
    JetInput,
    JetLabel,
    JetValidationErrors
  },

  props: {
    status: String
  },

  data() {
    return {
      form: this.$inertia.form({
        email: ''
      })
    }
  },

  methods: {
    submit() {
      this.form.post(this.route('password.email'))
    }
  }
}
</script>



